import { createStore } from 'vuex'
//import companies from './modules/companies.js';
import sidemenu from './modules/sidemenu';
import settings from './modules/settings';
import kooi from './modules/kooi';
import companies from './modules/companies';
import products from './modules/products';
import productcategories from './modules/productcategories';
import labels from './modules/labels';
import addresses from './modules/addresses';
import dashboardInbox from './modules/dashboard/dashboard-inbox';
import dashboardEvents from './modules/dashboard/dashboard-events';
import dashboardInvoices from './modules/dashboard/dashboard-invoices';
import dashboardChart from './modules/dashboard/dashboard-chart';
import textblocks from './modules/textblocks';
import currencies from './modules/currencies';
import logisticBlocks from './modules/logistic-blocks';
import logisticTemplates from './modules/logistic-templates';
import conditions from './modules/conditions';
import lang from './modules/lang';
import users from './modules/users';
import commissionBlocks from './modules/commission-blocks';
import pobox from './modules/pobox';
import ooi from './modules/ooi';
import pricelists from './modules/pricelists';
import temporary from './modules/temporary';
import units from './modules/units';
import notes from './modules/notes';
import emailTemplates from './modules/email-templates';
import apitoken from './modules/apitoken';
import groups from './modules/groups';
import pdfTranslations from './modules/pdf-translations';
import releases from './modules/releases';
import notifications from './modules/notifications';
import quickOverview from './modules/dashboard/quick-overview';
import browserTabs from './modules/browserTabs';
import search from './modules/global-search';
import auth from './modules/auth';
import documentTypes from './modules/documentTypes';
const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    sidemenu,
    settings,
    users,
    lang,
    kooi,
    companies,
    products,
    productcategories,
    labels,
    addresses,
    dashboardInbox,
    dashboardEvents,
    dashboardInvoices,
    dashboardChart,
    logisticTemplates,
    logisticBlocks,
    textblocks,
    currencies,
    commissionBlocks,
    pobox,
    ooi,
    conditions,
    pricelists,
    temporary,
    units,
    notes,
    emailTemplates,
    apitoken,
    groups,
    pdfTranslations,
    releases,
    notifications,
    quickOverview,
    browserTabs,
    search,
    documentTypes,
    auth,
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
  plugins: debug ? [] : []
})
